module.exports = __webpack_public_path__ + "img/dingbu.a3110099.png";